import {
  Box,
  Snackbar,
  Alert,
  Modal,
  Typography,
  IconButton,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import NewListComponent from "../Templates/NewListComponent";
import {
  deviceDefinition,
} from "../api/devices";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { deviceRemoteSSHPath } from "../../routes";
import RemoteSSH from "./RemoteSSH";
import { generateDeviceCommand } from "../newBackendApi/newDevices";
import { listDevices } from "../newBackendApi/newDevices";

const Devices = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [formObject, setFormObject] = useState(deviceDefinition);

  const [layoutView, setLayoutView] = useState("list");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [showAddDeviceModal, setShowAddDeviceModal] = useState(false);
  const [commandText, setCommandText] = useState("");
  const [isCommandExpanded, setIsCommandExpanded] = useState(false);
  const [, setNeedsExpansion] = useState(false);
  const [openRemoteSSH] = useState(false)
  const [deviceId] = useState(null)
  const [isPropertyLoading] = useState(false)
const [limit] = useState(10); // Adjust default page_size if needed
  const [pageNumber, setPageNumber] = useState(1); 
    const textRef = useRef(null);
  const navigate = useNavigate();
 const [isLoading, setIsLoading] = useState(false);
  const [devicesData, setDevicesData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "723px",
    height:"727px",
    maxWidth: "800px",
    maxHeight:"80vh",
    overflowy:"auto",
    // Deliberately dark in both themes — this panel's content is styled as a
    // dark console (white text, #111317 cards). Was "101010" (no #), i.e. an
    // invalid colour, so the modal had no background at all.
    bgcolor: "#101010",
    borderRadius: "12px",
    boxShadow: 24,
    
  };






  

const fetchDevice = async () => {
    setIsLoading(true);
    try {
      const { devices, count } = await listDevices({
        page_number: pageNumber,
        page_size: limit,
      });
      setTotalCount(count);
      setDevicesData(
        devices.map((d) => ({
          ...d,
          registered_at: formatDate(d.registered_at),
          warranty_end_date: formatDate(d.warranty_end_date),
        }))
      );
    } catch (error) {
      showSnackbar(error.message || "Failed to fetch devices", "error");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchDevice();
    // fetchDevice is redefined on every render, so listing it here would refetch
    // in a loop. Paging is what should drive a refetch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, limit]); 

  useEffect(() => {
    if (textRef.current && commandText) {
      const isOverflowing = textRef.current.scrollHeight > textRef.current.clientHeight;
      setNeedsExpansion(isOverflowing);
    }
  }, [commandText]);

  const handleLayoutChange = (layout) => {
    setLayoutView(layout);
  };


  const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  return date.toLocaleDateString("en-IN", {
  year: "numeric",
  month: "short",
  day: "numeric",
});
};

  const columns = [
    {
      id: "serial_number",
      label: "Serial Number",
      type: "textfield",
      display: true,
      onClick: (row) => handleNavigate(row),
    },
    {
      id: "warranty_status",
      label: "Status",
      type: "dropdown",
      display: true,
      options: [
        { value: "active", label: "Active" },
        { value: "expired", label: "Expired" },
        { value: "voided", label: "Voided" },
      ],
      onClick: (row) => handleNavigate(row),
    },
    {
      id: "registered_at",
      label: "Registered At",
      type: "textfield",
      display: true,
      onClick: (row) => handleNavigate(row),
    },
    {
      id: "warranty_end_date",
      label: "Warranty End Date",
      type: "textfield",
      display: true,
      onClick: (row) => handleNavigate(row),
    },
  ];

  function handleNavigate(row) {
    if (!row) return;
    navigate(deviceRemoteSSHPath(row?.id), {
      state: { data: row },
    });
  }



  

  const handleRefreshClick = async () => {
    setDevicesData([]);
    await fetchDevice();
  };

 


  const handleCopyCommand = () => {
    navigator.clipboard.writeText(commandText).then(() => {
      showSnackbar("Command copied to clipboard!", "success");
    });
  };


  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };


    // Add these states
  const [verifyStatus, setVerifyStatus] = useState("waiting"); // "waiting" | "success" | "error"
  const [verifyLogs, setVerifyLogs] = useState([]);

  // Call this when Next is clicked (step 0 → 1)
  const handleNext = async () => {
    setActiveStep(1);
    setVerifyStatus("waiting");
    setVerifyLogs([]);
    await pollDeviceRegistration();
  };

  // const pollDeviceRegistration = async () => {
  //   const logs = [
  //     "Serial code is been written...",
  //     "Serial code is been verified...",
  //     "Registering your device...",
  //   ];

  //   // Simulate log lines appearing one by one
  //   for (let i = 0; i < logs.length; i++) {
  //     await new Promise((r) => setTimeout(r, 1200));
  //     setVerifyLogs((prev) => [...prev, { text: logs[i], status: "normal" }]);
  //   }

  //   // Poll for actual device registration
  //   let attempts = 0;
  //   const maxAttempts = 20;
  //   const interval = setInterval(async () => {
  //     attempts++;
  //     try {
  //       const devices = await listDevices({ page_number: 1, page_size: 50 });
  //       const found = devices?.find((d) => d.deviceName === deviceName);
  //       if (found) {
  //         clearInterval(interval);
  //         setVerifyLogs((prev) => [
  //           ...prev,
  //           { text: `Device online — ${deviceName} is registered`, status: "success" },
  //         ]);
  //         setVerifyStatus("success");
  //         fetchDevice(); // refresh table
  //       } else if (attempts >= maxAttempts) {
  //         clearInterval(interval);
  //         setVerifyLogs((prev) => [
  //           ...prev,
  //           { text: "Handshake failed — connection timed out (10s)", status: "error" },
  //         ]);
  //         setVerifyStatus("error");
  //       }
  //     } catch (e) {
  //       clearInterval(interval);
  //       setVerifyLogs((prev) => [
  //         ...prev,
  //         { text: "Handshake failed — connection timed out (10s)", status: "error" },
  //       ]);
  //       setVerifyStatus("error");
  //     }
  //   }, 3000);
  // };

    const pollDeviceRegistration = async () => {
      const logs = [
        "Serial code is been written...",
        "Serial code is been verified...",
        "Registering your device...",
      ];

      for (let i = 0; i < logs.length; i++) {
        await new Promise((r) => setTimeout(r, 1200));
        setVerifyLogs((prev) => [...prev, { text: logs[i], status: "normal" }]);
      }

      // Demo: always succeed after logs finish
      await new Promise((r) => setTimeout(r, 800));
      setVerifyLogs((prev) => [
        ...prev,
        { text: `Device online — ${deviceName || "demo-device"} is registered`, status: "success" },
      ]);
      setVerifyStatus("success");
      fetchDevice();
    };


    //logic for timer state
    const [timer, setTimer] = useState(600); // 10 minutes in seconds
    const timerRef = useRef(null);

    // Start timer when modal opens
    const handleAddClick = async () => {
      const res = await generateDeviceCommand();
      setCommandText(`${res?.command}`);
      setShowAddDeviceModal(true);
      setTimer(600);
      //startTimer();
    };

    const startTimer = () => {
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    };

    const handleRegenerate = async () => {
      const res = await generateDeviceCommand();
      setCommandText(`${res?.command}`);
      setTimer(600);
      //startTimer();
    };

    // Clear timer on modal close
    const handleCloseAddDeviceModal = () => {
      if (timerRef.current) clearInterval(timerRef.current);
      setShowAddDeviceModal(false);
      setCommandText("");
      setTimer(600);
      setActiveStep(0);
      setVerifyStatus("waiting");
      setVerifyLogs([]);
      setIsCommandExpanded(false)
    };


  const [deviceName,setDeviceName]=useState("")
  const [product, setProduct] = useState("JETCORE");

  const [activeStep, setActiveStep] = useState(0);

  return (
    <Box
      sx={{
        padding: 1,
        boxSizing: "border-box",
        height: "100%",
        position: "relative",
      }}
    >
      <Box sx={{
        display: 'flex',
        height: '100%'
      }}>
        <Box sx={{
          width: openRemoteSSH ? '50%' : '100%',
          transition: 'all 0.3s ease'
        }}>
          <NewListComponent
            title="Devices"
            subtitle="Backed by services/devices: registry records, drone links, and the remote SSH hardware identity"
            columns={columns}
            isLoading={isLoading}
            isPropertyLoading={isPropertyLoading}
            showAddButton={true}
            addButtonText="Add Device"
            data={devicesData || []}
            onRefresh={handleRefreshClick}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            setShowAddForm={handleAddClick}
            formObject={formObject}
            setFormObject={setFormObject}
            onLayoutChange={handleLayoutChange}
            layoutView={layoutView}
            object="device"
            isServerPagination={true}
            totalCount={totalCount}
            page={pageNumber}
            onPageChange={(_, value) => setPageNumber(value)}
            limit={limit}
          />
        </Box>
        <Box sx={{
          display: openRemoteSSH ? 'block' : 'none',
          transition: 'all 0.3s ease'
        }}>
          {/* Mount the terminal only once a device is opened — otherwise
              ProductionTerminal fires a live PubSub subscription on the list page
              (deviceId "null"), which rejects and surfaces as an uncaught error. */}
          {openRemoteSSH && <RemoteSSH deviceId={deviceId} />}
        </Box>
      </Box>


      {/* <Modal
        open={showAddDeviceModal}
        onClose={handleCloseAddDeviceModal}
        aria-labelledby="modal-title"
      >
        <Box sx={modalStyle}>
          <Box
            sx={{
              p: 2,
              borderBottom: "1px solid #1f1f1f",
              position: "relative",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: "24px",
                fontWeight: 600,
              }}
            >
              Register New Device
            </Typography>

            <Typography
              sx={{
                color: "#777",
                fontSize: "14px",
                mt: 0.5,
              }}
            >
              Connect your hardware to the Vecros fleet
            </Typography>

            <IconButton
              onClick={handleCloseAddDeviceModal}
              sx={{
                position: "absolute",
                right: 16,
                top: 16,
                color: "#999",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          
            
              <Stepper
              activeStep={activeStep}
              connector={<></>}
              sx={{
                mb: 2,
                "& .MuiStepConnector-line": { display: "none" },
                "& .css-35l7u0-MuiStepConnector-line": { display: "none" },
                "& .MuiStep-root": { padding: 0 },
                 "& .MuiStepLabel-root": { padding: 0 },
              }}
              >
                <Step>
                  <StepLabel>Configure & Install agent</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Verify</StepLabel>
                </Step>
              </Stepper>
            

            <Box
              sx={{
                backgroundColor: theme.palette.primary.main,
                borderRadius: 1,
                p: 2,
                mb: 2,
                border: `1px solid ${theme.palette.border.color}`,
                position: "relative",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: needsExpansion ? 1 : 0 }}>
                <Box
                  ref={textRef}
                  sx={{
                    flex: 1,
                    maxHeight: isCommandExpanded ? "auto" : "1em",
                    overflow: "hidden",
                    transition: "max-height 0.3s ease",
                  }}
                >
                  <Typography
                    component="pre"
                    sx={{
                      color: "#68d391",
                      fontFamily: "monospace",
                      fontSize: "14px",
                      margin: 0,
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    <span style={{ color: "#68d391" }}>❯ </span>
                    <span style={{ color: theme.palette.text.color }}>
                      {commandText}
                    </span>
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                  <IconButton
                    onClick={handleCopyCommand}
                    sx={{
                      backgroundColor: "#4299e1",
                      color: "white",
                      width: 36,
                      height: 36,
                      "&:hover": { backgroundColor: "#3182ce" },
                    }}
                    size="small"
                  >     
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </Box>
                </Box>
              <Box
                sx={{
                  px: 5,
                  mt: 4,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 3,
                }}
              >
                <TextField
                  label="Device Name"
                  value={deviceName}
                  onChange={(e) => setDeviceName(e.target.value)}
                  fullWidth
                />

                <TextField
                  select
                  label="Product"
                  value={product}
                  onChange={(e) => setProduct(e.target.value)}
                  fullWidth
                >
                  <MenuItem value="JETCORE">
                    JETCORE
                  </MenuItem>
                </TextField>
              </Box>


              <Button
                onClick={toggleCommandExpansion}
                sx={{
                  alignSelf: "flex-start",
                  minWidth: "auto",
                  p: 0.5,
                  color: "#68d391",
                  fontSize: "12px",
                  textDecoration: "none",
                  "&:hover": {
                    backgroundColor: "transparent",
                    textDecoration: "underline",
                  },
                }}
                endIcon={isCommandExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              >
                {isCommandExpanded ? "Show less" : "Show full command"}
              </Button>


              {needsExpansion && (
                <Button
                  onClick={toggleCommandExpansion}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    mt: 1,
                    color: "#68d391",
                    fontSize: "12px",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                  endIcon={isCommandExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                >
                  {isCommandExpanded ? "Show less" : "Show full command"}
                </Button>
              )}

            
            

            <Button
              onClick={handleCloseAddDeviceModal}
              variant="contained"
              fullWidth
              sx={{
                mt: 4,
                backgroundColor: "#006bce",
                color: "white",
                textTransform: "none",
                py: 1.5,
                "&:hover": { backgroundColor: "#0058A5" },
              }}
            >
              Close
            </Button>
          </Box>
        
        </Box>
      </Modal> */}

   <Modal open={showAddDeviceModal} onClose={handleCloseAddDeviceModal}>
  <Box sx={modalStyle}>
    {/* Header */}
    <Box sx={{ p: 2, borderBottom: "1px solid #1f1f1f", position: "relative" }}>
      <Typography sx={{ color: "#fff", fontSize: "16px", fontWeight: 600 }}>
        Register New Device
      </Typography>
      <Typography sx={{ color: "#777", fontSize: "11px", mt: 0.5 }}>
        Connect your hardware to the Vecros fleet
      </Typography>
      <IconButton onClick={handleCloseAddDeviceModal}
        sx={{ position: "absolute", right: 12, top: 12, color: "#999" }}>
        <CloseIcon />
      </IconButton>
    </Box>
    <Box sx={{ p: 2}}>
      {/* Custom Stepper */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 4,mt:2 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1,paddingLeft:"100px" }}>
      <Box sx={{
        width: 20, height:20, borderRadius: "50%",
        background: activeStep >= 0 ? "#2563eb" : "rgba(255,255,255,0.1)",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: "12px", color: "#fff", fontWeight: 500,
      }}>
        {activeStep > 0 ? "✓" : "1"}
      </Box>
      <Typography sx={{ fontSize: "14px", fontWeight: 500,
        color: activeStep === 0 ? "#fff" : "rgba(255,255,255,0.5)" }}>
        Configure & Install agent
      </Typography>
    </Box>
    <Box sx={{  height: "1px", background: "rgba(255,255,255,0.15)", mx: 2 , width:"200px"}} />
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box sx={{
        width: 28, height: 28, borderRadius: "50%",
        background: activeStep >= 1 ? "#2563eb" : "rgba(255,255,255,0.1)",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: "13px", color: activeStep >= 1 ? "#fff" : "rgba(255,255,255,0.4)",
        fontWeight: 500,
      }}>
        2
      </Box>
      <Typography sx={{ fontSize: "14px", fontWeight: 500,
        color: activeStep === 1 ? "#fff" : "rgba(255,255,255,0.4)" }}>
        Verify
      </Typography>
    </Box>
  </Box>

  {/* STEP 1 content */}
  {activeStep === 0 && (
    <Box>
      {/* Device Name + Product */}
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 2}}>
        <TextField
          label="Device name" required
          
          placeholder="e.g. jetcore-unit-0.7"
          value={deviceName}
          onChange={(e) => setDeviceName(e.target.value)}
          fullWidth size="small"
          InputLabelProps={{
          sx: { fontSize: "14px" },
           }}
          InputProps={{
           sx: {
          fontSize: "14px",
          "& input::placeholder": {
            fontSize: "12px",
            opacity: 1,
          },
        },
      }}
          
        />
        <TextField
          select label="Product" required
          value={product}
          onChange={(e) => setProduct(e.target.value)}
          fullWidth size="small"
          InputLabelProps={{
          sx: { fontSize: "14px" },
          }}
          InputProps={{
           sx: { fontSize: "14px" },
           }}
        >
          <MenuItem value="JETCORE">JETCORE</MenuItem>
        </TextField>
      </Box>

      {/* How to register */}
      <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#555",
        letterSpacing: "0.08em", textTransform: "uppercase", mb: 1 }}>
        How to register your device
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 1, mb: 2 ,height:110}}>
        {[
          "Open a terminal on your device.",
          "Reveal your command below and copy it.",
          "Paste and run the command. The agent installs, writes the registry record, and creates the drone link.",
          "Click Next. Your device appears in the table automatically.",
        ].map((text, i) => (
          <Box key={i} sx={{
            background: "#111317", border: "0.5px solid rgba(255,255,255,0.08)",
            borderRadius: "12px", p: 1,
          }}>
            <Box sx={{
              width: 22, height: 22, borderRadius: "50%", background: "#2563eb",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: "13px", color: "#fff", mb: 1,
            }}>{i + 1}</Box>
            <Typography sx={{ fontSize: "12px", color: "rgba(255,255,255,0.6)", lineHeight: 1.5 }}>
              {text}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Command Box */}
      <Box sx={{
        background: "#111317",
        height:110,
        border: "0.5px solid rgba(255,255,255,0.15)",
        borderRadius: "8px",
        mb: 1.5, overflow: "hidden",
        mt:1
      }}>
        {/* Terminal dots */}
        <Box sx={{ display: "flex", gap: 1, px: 2, pt: 1.5, pb: 1 }}>
          <Box sx={{ width: 10, height: 10, borderRadius: "50%", background: "rgba(255,255,255,0.2)" }} />
          <Box sx={{ width: 10, height: 10, borderRadius: "50%", background: "rgba(255,255,255,0.2)" }} />
          <Box sx={{ width: 10, height: 10, borderRadius: "50%", background: "rgba(255,255,255,0.2)" }} />
        </Box>

        {/* Before reveal — blurred + button */}
        {!isCommandExpanded ? (
          <Box sx={{ px: 2, pb: 2, display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
            <Typography component="pre" sx={{
              color: "rgba(255,255,255,0.35)", fontFamily: "monospace", fontSize: "13px",
              filter: "blur(4px)", userSelect: "none", pointerEvents: "none",
              whiteSpace: "pre-wrap", wordBreak: "break-all",
              width: "100%", lineHeight: 1.8, m: 0,
            }}>
              {commandText || "curl -sO https://vecros-jetcore-installer.s3.eu-north-1.amazonaws.com/install.sh && sudo bash install.sh --token ey••••••••••"}
            </Typography>
            <Button variant="contained" onClick={() => {
              setIsCommandExpanded(true)
              startTimer()
            } }
              sx={{ background: "#2563eb", color: "#fff", textTransform: "none",
                fontSize: "11px", px: 3, py: 0.8, borderRadius: "6px",marginTop:"-40px",
                "&:hover": { background: "#1d4ed8" } }}>
              View your command
            </Button>
            <Typography sx={{ fontSize: "11px", color: "rgba(255,255,255,0.35)" }}>
              Click to reveal · expires in 10 min after reveal
            </Typography>
          </Box>
        ) : (
          /* After reveal — actual command + copy */
          <Box sx={{ px: 2, pb: 1 }}>
            <Typography component="pre" sx={{
              color: "rgba(255,255,255,0.85)", fontFamily: "monospace", fontSize: "13px",
              whiteSpace: "pre-wrap", wordBreak: "break-all",
              m: 0, lineHeight: 1.8,
            }}>
              {commandText}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
              <Button onClick={handleCopyCommand} size="small"
                startIcon={<ContentCopyIcon fontSize="small" />}
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  border: "0.5px solid rgba(255,255,255,0.2)",
                  borderRadius: "6px", textTransform: "none",
                  fontSize: "12px", px: 1.5, py: 0.5,
                  "&:hover": { background: "rgba(255,255,255,0.05)" },
                }}>
                Copy
              </Button>
            </Box>
          </Box>
        )}
      </Box>
       {/* Timer + Regenerate */}
        {isCommandExpanded &&
         
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography sx={{ fontSize: "12px", color: "rgba(255,255,255,0.4)" }}>
              Command expires in{" "}
              <span style={{ color: "rgba(255,255,255,0.7)", fontWeight: 500 }}>
                {Math.floor(timer / 60)}:{String(timer % 60).padStart(2, "0")}
              </span>
            </Typography>
            <Button
              onClick={handleRegenerate}
              sx={{ color: "#2563eb", textTransform: "none", fontSize: "12px", p: 0,
                minWidth: "auto", "&:hover": { background: "transparent", textDecoration: "underline" } }}
            >
              Regenerate
            </Button>
          </Box>
}

      {/* Warning */}
      <Box sx={{
        background: "#2a2208", border: "0.5px solid #6b4c00",
        borderRadius: "8px", p: 1, mb: 2,
        display: "flex", gap: 1.5, alignItems: "flex-start",
      }}>
        <Typography sx={{ color: "#f59e0b", fontSize: "16px", lineHeight: 1 }}>⚠</Typography>
        <Typography sx={{ fontSize: "12px", color: "rgba(255,255,255,0.6)", lineHeight: 1.6 }}>
          <strong style={{ color: "rgba(255,255,255,0.8)" }}>Note:</strong>{" "}
          The generated activation command expires{" "}
          <strong style={{ color: "#f59e0b" }}>10 minutes</strong>{" "}
          after you reveal it. If it expires, click{" "}
          <strong style={{ color: "#f59e0b" }}>Regenerate</strong> to get a new one.
          Do not share this command, it contains a single-use authentication token tied to your organization.
        </Typography>
      </Box>

      {/* Buttons */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5 }}>
        <Button onClick={handleCloseAddDeviceModal} variant="outlined"
          sx={{ color: "rgba(255,255,255,0.7)", borderColor: "rgba(255,255,255,0.2)",
            textTransform: "none", "&:hover": { background: "transparent" } }}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleNext}
          sx={{ background: "#2563eb", color: "#fff", textTransform: "none", px: 4,
            "&:hover": { background: "#1d4ed8" } }}>
          Next
        </Button>
      </Box>
    </Box>
  )}

  {/* STEP 2 content */}
  {activeStep === 1 && (
    <Box sx={{ textAlign: "center", py: 2 }}>
      {verifyStatus === "waiting" && (
        <Box sx={{ fontSize: "56px", mb: 1, display: "inline-block",
          animation: "spin 2s linear infinite",
          "@keyframes spin": { from: { transform: "rotate(0deg)" }, to: { transform: "rotate(360deg)" } },
        }}>⏳</Box>
      )}
      {verifyStatus === "success" && (
        <Box sx={{ width: 64, height: 64, borderRadius: "50%",
          border: "2px solid #22c55e", display: "flex",
          alignItems: "center", justifyContent: "center", mx: "auto", mb: 1.5 }}>
          <Typography sx={{ color: "#22c55e", fontSize: "32px", lineHeight: 1 }}>✓</Typography>
        </Box>
      )}
      {verifyStatus === "error" && (
        <Box sx={{ width: 64, height: 64, borderRadius: "50%",
          border: "2px solid #ef4444", display: "flex",
          alignItems: "center", justifyContent: "center", mx: "auto", mb: 1.5 }}>
          <Typography sx={{ color: "#ef4444", fontSize: "32px", lineHeight: 1 }}>✕</Typography>
        </Box>
      )}

      {verifyStatus === "waiting" && (
        <>
          <Typography sx={{ color: "#fff", fontSize: "16px", fontWeight: 500, mb: 0.5 }}>
            Waiting for device handshake...
          </Typography>
          <Typography sx={{ color: "#666", fontSize: "12px", mb: 2 }}>
            Keep this window open. The device will appear automatically once the agent connects.
          </Typography>
        </>
      )}
      {verifyStatus === "success" && (
        <>
          <Typography sx={{ color: "#22c55e", fontSize: "16px", fontWeight: 500, mb: 0.5 }}>
            Device registered successfully!
          </Typography>
          <Typography sx={{ color: "#666", fontSize: "12px", mb: 2 }}>
            Your device is now live in the fleet.
          </Typography>
        </>
      )}
      {verifyStatus === "error" && (
        <>
          <Typography sx={{ color: "#ef4444", fontSize: "16px", fontWeight: 500, mb: 0.5 }}>
            Device registration failed!
          </Typography>
          <Typography sx={{ color: "#666", fontSize: "12px", mb: 2 }}>
            The agent could not reach the VECROS server. Please check your network or registration configuration.
          </Typography>
        </>
      )}

      {/* Logs */}
      <Box sx={{ background: "#111317", border: "0.5px solid rgba(255,255,255,0.08)",
        borderRadius: "8px", p: 2, textAlign: "left" }}>
        {verifyLogs.map((log, i) => (
          <Typography key={i} component="div"
            sx={{ fontFamily: "monospace", fontSize: "12px", lineHeight: 2,
              color: log.status === "success" ? "#22c55e"
                   : log.status === "error" ? "#ef4444"
                   : "rgba(255,255,255,0.5)",
              display: "flex", alignItems: "center", gap: 1 }}>
            <span style={{ color: log.status === "success" ? "#22c55e"
                                : log.status === "error" ? "#ef4444" : "#555" }}>
              {log.status === "success" ? "●" : log.status === "error" ? "●" : "·"}
            </span>
            {log.text}
          </Typography>
        ))}
      </Box>

      {/* Footer */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        {verifyStatus === "error" && (
          <Button variant="outlined" onClick={() => { setActiveStep(0); setVerifyLogs([]); }}
            sx={{ color: "rgba(255,255,255,0.7)", borderColor: "rgba(255,255,255,0.2)",
              textTransform: "none", mr: 1.5, "&:hover": { background: "transparent" } }}>
            Back
          </Button>
        )}
        <Button variant="contained" onClick={handleCloseAddDeviceModal}
          disabled={verifyStatus === "waiting"}
          sx={{ background: verifyStatus === "error" ? "#ef4444" : "#2563eb",
            color: "#fff", textTransform: "none", px: 4,
            "&:hover": { background: verifyStatus === "error" ? "#dc2626" : "#1d4ed8" },
            "&.Mui-disabled": { background: "#333", color: "#666" } }}>
          Done
        </Button>
      </Box>
    </Box>
  )}
</Box>
  </Box>
</Modal>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Devices;
